import * as React from "react"
import { saInterfaceApprenticeLogosContainer } from "../saTypes"
// @ts-ignore
import { saLogosGalleryContainer, saLogosGallery, saLogosGalleryList, saLogosGalleryItem, saLogosGallerySectionTitle } from './saLogosGallery.module.scss'
import SaImage from "../saImage/saImage"
import { SaTitle } from "../saTitle/saTitle"




export const SaLogosGallery:React.FC<saInterfaceApprenticeLogosContainer> = ({...props}) => {

  let saLogos = props.logos.map((item,index) => (
      <div key={index} className={saLogosGalleryItem}>
        <SaImage {...item.image} />
      </div>
    )
  )

  return (
    <div className={saLogosGalleryContainer}>
      <div className={'saContainer ' + saLogosGallery}>

        {
          props.sectionTitle
          &&
          <SaTitle title={props.sectionTitle} classes={saLogosGallerySectionTitle}/>
        }

        <div className={saLogosGalleryList}>
          { saLogos }
        </div>

      </div>
    </div>
  )

}